import React from "react";
import { useTranslation } from "react-i18next";
import { ModalBuilder, Form, Table, ActionMenu } from "@redriver/cinnamon";
import { setSheetOwners } from "../actions";
import { withRouter } from "react-router-dom";
import { SheetActionUserTypeAhead, UserTypeAhead } from "features/Settings";
import { withCurrentUser } from "features/../../../shared/components/auth";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";

const SetSheetOwner = ({
  sheetId,
  ownedBy = {},
  dealerId,
  onSubmitted,
  currentUser,
}) => {
  const { t } = useTranslation("agreements");
  const { isInternalUser } = currentUser;
  return (
    <ModalBuilder
      withForm
      submitAction={setSheetOwners}
      submitParams={{ sheetId, dealerId }}
      initialData={{
        ownedById: ownedBy?.id,
        ownedByName: ownedBy?.name,
      }}
      onSubmitted={onSubmitted}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.SetOwner.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps, formProps) => (
        <TranslatedModal
          {...modalProps}
          header={t("SheetActions.SetOwner.HeaderText")}
          size="small"
        >
          <Form {...formProps}>
            <SheetActionUserTypeAhead
              clearable
              fluid
              field="ownedById"
              textField="ownedByName"
              label={t("SheetActions.SetOwner.Owner_Label")}
              placeholder={t("SheetActions.SetOwner.Owner_Placeholder")}
              lookupParams={{
                includeEmail: true,
                includeUserArea: true,
                includeInternalUsers: isInternalUser,
                dealerId,
              }}
            />
          </Form>
        </TranslatedModal>
      )}
    />
  );
};

export default withCurrentUser(withRouter(SetSheetOwner));
